const mapSpaEnabledCountries = configuration => {
  return configuration.paymentMethod.sharedPaymentAccount.enabledForCountries;
};

export default {
  mapSpaEnabledCountries,
};
